import { Box, Switch, Text, useToast } from "@chakra-ui/react";
import * as React from "react";
import { showErrorToast } from "../../../../utils";
import { useGetScopeOneConversionFactors } from "../../../../hooks/query/conversion-factors";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { mapScopeOneFactorsData } from "../helpers";
import { DataTable } from "../../../../components/DataTable";
import { toggleConversionFactorEnabled } from "../../../../api/conversion-factors/conversion-factors";

function ScopeOneFactorsTab({ selectedYear, setSelectedYear, organizationStructure }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "conversionFactors.headers"
  });
  const { t: globalTranslation } = useTranslation("translation");
  const toast = useToast();

  const [scopeOneFactorsData, setScopeOneFactorsData] = useState([]);

  const {
    isFetching
  } = useGetScopeOneConversionFactors({
    year: selectedYear
  }, {
    onSuccess: (data) => {
      if (data && data.length > 0) {
        setScopeOneFactorsData(mapScopeOneFactorsData(data));
      } else {
        setScopeOneFactorsData([]);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  const allOrgConsumptionTypes = useMemo(() => {
    if (!organizationStructure) return [];
    return [
      ...(organizationStructure.stationaryConsumptionTypes || []),
      ...(organizationStructure.mobileConsumptionTypes || []),
      ...(organizationStructure.refrigerantConsumptionTypes || []),
    ];
  }, [organizationStructure]);

  const isConsumptionTypeEnabled = (row) => {
    return allOrgConsumptionTypes.some((ct) => ct.name === row._consumptionTypeName);
  };

  const columns = useMemo(() => {
    return [
      {
        header: t("enabled"),
        accessorKey: "_enabled",
        size: 80,
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <Switch
            size="sm"
            colorScheme="green"
            isChecked={isConsumptionTypeEnabled(row.original)}
            onChange={(e) => toggleConversionFactorEnabled({
              scope: "scope1",
              typeId: row.original._consumptionTypeId,
              typeName: row.original._consumptionTypeName,
              enabled: e.target.checked,
            })}
          />
        ),
      },
      {
        header: t("consumptionType"),
        accessorKey: "consumptionType",
        size: 150
      },
      {
        header: t("measurementUnit"),
        accessorKey: "measurementUnit",
        size: 100
      },
      {
        header: t("conversionFactor"),
        accessorKey: "conversionFactor",
        size: 200,
        enableColumnFilter: false
      },
      {
        header: t("calorificValue"),
        accessorKey: "calorificValue",
        size: 200,
        enableColumnFilter: false
      },
      {
        header: t("source"),
        accessorKey: "source",
        size: 150
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, allOrgConsumptionTypes]);

  return (
    <Box>
      {!scopeOneFactorsData || scopeOneFactorsData.length === 0 ?
        <Text fontSize="lg" fontWeight="bold">
          {globalTranslation("noDataAvailable")}
        </Text> :
        <DataTable
          data={scopeOneFactorsData}
          columns={columns}
          isLoading={isFetching}
          enableFilters={true}
        />
      }
    </Box>
  );
}

export default ScopeOneFactorsTab;